import React, { useEffect, useState } from "react";
import "./viewagent.css";
import { Modal, Button } from "react-bootstrap";
import { IoIosArrowBack } from "react-icons/io";

const ViewAgentModal = ({ show, handleClose, agentData }) => {
  const [name, setName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [target, setTarget] = useState("");
const [assignedManager, setAssignedManager] = useState("");
  useEffect(() => {
    if (agentData) {
      setName(agentData.agentName || "");
      setEmail(agentData.agentEmail || "");
      setMobileNumber(agentData.agentNumber || "");
      setTarget(agentData.target?.toString() || "");
      setAssignedManager(agentData.manager?.name || undefined);
    }
  }, [agentData]);

  const handleBackButton = () => {
    handleClose();
  };
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        centered
        backdrop="static"
        dialogClassName="custom-agent-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form>
            <div className="container-fluid">
              {/* Row 1 */}
              <div className="row">
                <div className="col-md-12">
                  <label className="form-label">Agent Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={name}
                    readOnly
                  />
                </div>

                <div className="col-md-12">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    readOnly
                  />
                </div>
                <div className="col-md-12">
                  <label className="form-label">Mobile Number</label>
                  <input
                    type="tel"
                    className="form-control"
                    readOnly
                    value={mobileNumber}
                  />
                </div>

                <div className="col-md-12 mb-3">
                  <label className="form-label">Target</label>
                  <input
                    type="number"
                    value={target}
                    className="form-control"
                    readOnly
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <label className="form-label">Assigned Manager</label>
                   <input
                    value={assignedManager}
                    className="form-control"
                    readOnly
                  />
                </div>

                {/* Buttons */}
                <div className="d-flex justify-content-end gap-2 mt-2">
                  <button
                    className="agents-back-button"
                    onClick={handleBackButton}
                    type="button"
                  >
                    <IoIosArrowBack /> Back
                  </button>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ViewAgentModal;
